// Transport DTOs for Employee Filtered endpoint (dimensional filtering)

import type { LC_PagedResult } from '@/api/shared';


export type EmployeeFilteredStatus = 'vigente' | 'no_vigente' | 'todos';

export const EMPLOYEE_FILTER_PAGE_SIZE = 200;

// Domain params — hooks use string[] arrays, service converts to CSV
export interface GetEmployeesFilteredParams {
  companyIds?: string[];
  areaIds?: string[];
  positionIds?: string[];
  costCenterIds?: string[];
  locationIds?: string[];
  contractModalityIds?: string[];
  groupIds?: string[];
  status?: EmployeeFilteredStatus | null;
  searchText?: string | null;
  page?: number;
  pageSize?: number;
  // Selected employee IDs to validate against the dimensional filters (universe-wide,
  // unpaginated). Only sent when pruning on a dimensional filter change.
  employeeIds?: number[];
}

// Request DTO — all dimensional filter params are CSV strings (e.g. "1,2,3")
export interface LC_GetEmployeesFilteredIn {
  companyIds?: string | null;
  areaIds?: string | null;
  positionIds?: string | null;
  costCenterIds?: string | null;
  locationIds?: string | null;
  contractModalityIds?: string | null;
  groupIds?: string | null;
  status?: EmployeeFilteredStatus | null;
  page?: number;
  pageSize?: number;
  searchText?: string | null;
  orderBy?: string | null;
  orderDirection?: 'ASC' | 'DESC' | null;
  employeeIds?: string | null;
}

// Response item DTO
export interface LC_FilteredEmployeeItem {
  employeeId: number;
  displayName: string;
}

// Response DTO — apiClient flattens the paginated envelope into LC_PagedResult and
// surfaces sibling fields (e.g. validatedSelection) alongside data + pagination.
export type LC_GetEmployeesFilteredOut = LC_PagedResult<LC_FilteredEmployeeItem> & {
  validatedSelection?: number[] | null;
};

// Internal UI model
export interface FilteredEmployee {
  employeeId: number;
  displayName: string;
}

export interface FilteredEmployeesPage {
  items: FilteredEmployee[];
  pagination: {
    currentPage: number;
    pageSize: number;
    totalRecords: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
  // Subset of the requested employeeIds that still satisfy all dimensional filters.
  validatedSelection: number[];
}
